import { execOnLoad, formatPrice } from '@general/helpers';
import './product-page.scss';
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/scss';
import 'swiper/scss/navigation';
import 'swiper/scss/pagination';
import breakpoints from 'breakpoints';
import { initProductForm } from '@components/product';
import { openMinicart } from '@components/minicart';
import { getOmnibus } from '@services/omnibus';
import { throttle } from 'lodash';
import {
  addToWishlist,
  deleteFromWishlist,
  getWishlist,
} from '@components/wishlist';
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import PhotoSwipe from 'photoswipe';
import 'photoswipe/style.css';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initProductPage = (context) => {
  const sectionContainer = context.classList.contains('.shopify-section')
    ? context
    : context.closest('.shopify-section');
  if (!sectionContainer) return;

  const bisButtons = sectionContainer.querySelectorAll(
    '.klaviyo-bis-trigger-custom',
  );
  const realBisButton = sectionContainer.querySelector('.klaviyo-bis-trigger');
  const wishlistButton = sectionContainer.querySelector(
    '[data-wishlist-btn-mobile]',
  );
  const wishlistButtonDesktop = sectionContainer.querySelector(
    '[data-wishlist-btn-desktop]',
  );
  const gallery = sectionContainer.querySelector(
    '.product-page__gallery-medias',
  );
  const realbisButtonWrapper = sectionContainer.querySelector(
    '.klaviyo-bis-trigger__wrapper',
  );

  sectionContainer
    .querySelector('.back-button')
    .addEventListener('click', function () {
      window.history.back();
    });

  if (gallery) {
    const icons = window?.dAgency?.icons;
    const lightbox = new PhotoSwipeLightbox({
      gallery: gallery,
      children: '.product-page__gallery-slide--image',
      pswpModule: PhotoSwipe,
      mainClass: 'pswp--custom',
      arrowPrev: true,
      arrowNext: true,
      zoom: false,
      close: true,
      counter: false,
      bgOpacity: 0.8,
      showHideAnimationType: 'fade',
      ...(icons
        ? {
            ...(icons.chevronLeft && icons.chevronRight
              ? {
                  arrowPrevSVG: icons.chevronLeft,
                  arrowNextSVG: icons.chevronRight,
                }
              : {}),
            ...(icons.close ? { closeSVG: icons.close } : {}),
          }
        : {}),
    });
    lightbox.init();

    const leftArrow = sectionContainer.querySelector(
      '.product-page__gallery-arrow--left',
    );
    const rightArrow = sectionContainer.querySelector(
      '.product-page__gallery-arrow--right',
    );
    const pagination = sectionContainer.querySelector(
      '.product-page__gallery-pagination',
    );
    const options = {
      loop: true,
      modules: [
        ...(leftArrow && rightArrow ? [Navigation] : []),
        ...(pagination ? [Pagination] : []),
      ],
      ...(leftArrow && rightArrow
        ? {
            navigation: {
              prevEl: leftArrow,
              nextEl: rightArrow,
            },
          }
        : {}),
      ...(pagination
        ? {
            pagination: {
              el: pagination,
              type: 'progressbar',
              clickable: true,
            },
          }
        : {}),
    };

    if (gallery.dataset.desktopMode != 'carousel') {
      var swiperGallery;
      const lgUp = window.matchMedia(`(min-width: ${breakpoints.lg})`);
      const handleSwiper = () => {
        if (lgUp.matches) {
          if (swiperGallery && swiperGallery.destroy)
            swiperGallery.destroy(true, true);
        } else {
          swiperGallery = new Swiper(gallery, options);
        }
      };
      handleSwiper();
      lgUp.addEventListener('change', handleSwiper);
    } else {
      const swiperGallery = new Swiper(gallery, options);
      const thumbnails = sectionContainer.querySelectorAll(
        '.product-page__gallery-thumbnails-item[data-index]',
      );
      if (thumbnails.length > 0) {
        thumbnails.forEach((thumbnail) =>
          thumbnail.addEventListener('click', () =>
            swiperGallery.slideToLoop(thumbnail.dataset.index),
          ),
        );
        swiperGallery.on('realIndexChange', () =>
          thumbnails.forEach(
            (thumbnail) =>
              (thumbnail.dataset.active =
                thumbnail.dataset.index == swiperGallery.realIndex),
          ),
        );
      }
    }
  }

  const form = sectionContainer.querySelector('.product-page__form');
  if (form) {
    const submit = form.querySelector('[type="submit"]');
    const errorWrapper = form.querySelector('.product-page__error-wrapper');
    const errorMessage = form.querySelector(
      '.product-page__error [data-message]',
    );
    const updateUrl = (variantId) => {
      const search = window.location.search
        .replace(/^\?/, '')
        .split('&')
        .reduce(
          (args, curr) => (/^variant=/.test(curr) ? args : [...args, curr]),
          [`variant=${variantId}`],
        )
        .filter((arg) => !!arg)
        .join('&');
      history.replaceState(null, '', `${window.location.pathname}?${search}`);
    };
    const updateOptions = ({ variant: selectedVariant }) => {
      for (const [key, value] of Object.entries(selectedVariant)) {
        if (key.includes('option') && key !== 'options') {
          if (value) {
            const selectorAttribute = key + '-' + value;
            document
              .querySelectorAll('.product-page__option-value')
              .forEach((option) => {
                option.classList.remove('option-active');
              });
            document
              .querySelector('#wrapper-' + selectorAttribute)
              .classList.add('option-active');
          }
        }
      }
    };

    const omnibusContainer = sectionContainer.querySelector(
      '.omnibus__container[data-sku][data-variant-price]',
    );
    const omnibusValue = sectionContainer.querySelector(
      '.omnibus__container [data-omnibus-value]',
    );
    const updateOmnibus = () => {
      if ((omnibusContainer, omnibusValue))
        getOmnibus({
          sku: omnibusContainer.dataset.sku,
          currency: omnibusContainer.dataset.currency,
          callbacks: {
            afterFetch: (omnibus) => {
              if (omnibus?.price) {
                if (
                  omnibus.price * 100 !==
                  parseInt(omnibusContainer.dataset.variantPrice)
                ) {
                  omnibusValue.innerText = formatPrice({
                    value: omnibus.price * 100,
                  });
                  omnibusContainer.classList.remove('hidden');
                } else {
                  omnibusContainer.classList.add('hidden');
                }
              } else {
                omnibusContainer.classList.add('hidden');
              }
            },
            errorCallback: () => {
              omnibusContainer.classList.add('hidden');
            },
          },
        });
    };
    updateOmnibus();

    initProductForm({
      form,
      callbacks: {
        afterVariantChange: async ({ variant, product }) => {
          updateUrl(variant.id);
          variant.options.forEach((option) => {
            const label = sectionContainer.querySelector(
              '.product-page__option--size',
            );
            const labelSelected = sectionContainer.querySelector(
              '.product-page__option--size-selected',
            );
            const submitReplacement =
              sectionContainer.querySelector('.btn-select-size');
            const addToCartButton =
              sectionContainer.querySelector('.btn-add-to-cart');
            if (label && labelSelected) {
              const labelSelectedSize = labelSelected.querySelector(
                '.product-page__option--size-selected__size',
              );
              if (labelSelectedSize) {
                label.style.display = 'none';
                labelSelected.style.display = 'inline-flex';
                labelSelectedSize.innerText = option;
              }
            }
            if (submitReplacement && addToCartButton) {
              submitReplacement.style.display = 'none';
              addToCartButton.style.display = 'block';
            }
            if (!variant.available) {
              addToCartButton.style.display = 'none';
              realbisButtonWrapper.style.display = 'inline-flex';
              realBisButton.style.display = 'inline-flex';
            } else {
              addToCartButton.style.display = 'block';
              realbisButtonWrapper.style.display = 'none';
              realBisButton.style.display = 'none';
            }
          });
          errorWrapper.classList.remove('shown');

          updateOptions({
            variant,
          });
          if (omnibusContainer && omnibusValue && variant.sku) {
            omnibusContainer.dataset.sku = variant.sku;
            omnibusContainer.dataset.variantPrice = variant.price;
            updateOmnibus();
          }

          if (wishlistButton) {
            wishlistButton.dataset.wishlistVariantId = variant?.id;
            wishlistButton.dataset.wishlistPrice = formatPrice({
              value: variant?.price ?? 0,
            });
            wishlistButton.dataset.wishlistCompareAtPrice =
              variant?.compare_at_price
                ? formatPrice({
                    value: variant?.compare_at_price,
                  })
                : '';

            const wishlist = await getWishlist();
            const wishlistProduct = wishlist?.listcontents?.find(
              (addedProduct) =>
                addedProduct.epi == variant.id &&
                addedProduct.empi == product.id,
            );
            wishlistButton.dataset.wishlistStatus = wishlistProduct
              ? 'active'
              : 'inactive';
          }
          if (wishlistButtonDesktop) {
            wishlistButtonDesktop.dataset.wishlistVariantId = variant?.id;
            wishlistButtonDesktop.dataset.wishlistPrice = formatPrice({
              value: variant?.price ?? 0,
            });
            wishlistButtonDesktop.dataset.wishlistCompareAtPrice =
              variant?.compare_at_price
                ? formatPrice({
                    value: variant?.compare_at_price,
                  })
                : '';

            const wishlist = await getWishlist();
            const wishlistProduct = wishlist?.listcontents?.find(
              (addedProduct) =>
                addedProduct.epi == variant.id &&
                addedProduct.empi == product.id,
            );
            wishlistButtonDesktop.dataset.wishlistStatus = wishlistProduct
              ? 'active'
              : 'inactive';
          }
        },
        beforeSubmit: () => {
          if (submit) submit.classList.add('loading');
        },
        afterSubmit: async () => {
          await openMinicart(true);
          if (submit) submit.classList.remove('loading');
        },
        errorCallback: (err) => {
          if (submit) submit.classList.remove('loading');
          if (errorWrapper && errorMessage && err?.data?.message) {
            errorMessage.innerText = err.data.message;
            requestAnimationFrame(() => {
              errorWrapper.classList.add('shown');
              setTimeout(() => {
                errorWrapper.classList.remove('shown');
              }, 3000);
            });
          }
        },
      },
    });
  }

  if (wishlistButton) {
    const toggleLoading = throttle(() => {
      wishlistButton.classList.toggle('loading');
    }, 500);
    wishlistButton.addEventListener('click', async (e) => {
      e.preventDefault();
      toggleLoading();
      const variantID = wishlistButton?.dataset?.wishlistVariantId;
      const masterID = wishlistButton?.dataset?.wishlistProductId;
      const productURL = wishlistButton?.dataset?.wishlistProductUrl;
      const price = wishlistButton?.dataset?.wishlistPrice;
      const compareAtPrice = wishlistButton?.dataset?.wishlistCompareAtPrice;

      if (wishlistButton?.dataset?.wishlistStatus === 'active') {
        await deleteFromWishlist({
          variantID,
          masterID,
          productURL,
        });
        wishlistButton.dataset.wishlistStatus = 'inactive';
      } else {
        await addToWishlist({
          variantID,
          masterID,
          productURL,
          compareAtPrice,
          price,
        });
        wishlistButton.dataset.wishlistStatus = 'active';
      }
      toggleLoading();
    });
  }

  if (wishlistButtonDesktop) {
    const toggleLoading = throttle(() => {
      wishlistButtonDesktop.classList.toggle('loading');
    }, 500);
    wishlistButtonDesktop.addEventListener('click', async (e) => {
      e.preventDefault();
      toggleLoading();
      const variantID = wishlistButtonDesktop?.dataset?.wishlistVariantId;
      const masterID = wishlistButtonDesktop?.dataset?.wishlistProductId;
      const productURL = wishlistButtonDesktop?.dataset?.wishlistProductUrl;
      const price = wishlistButtonDesktop?.dataset?.wishlistPrice;
      const compareAtPrice =
        wishlistButtonDesktop?.dataset?.wishlistCompareAtPrice;

      if (wishlistButtonDesktop?.dataset?.wishlistStatus === 'active') {
        await deleteFromWishlist({
          variantID,
          masterID,
          productURL,
        });
        wishlistButtonDesktop.dataset.wishlistStatus = 'inactive';
      } else {
        await addToWishlist({
          variantID,
          masterID,
          productURL,
          compareAtPrice,
          price,
        });
        wishlistButtonDesktop.dataset.wishlistStatus = 'active';
      }
      toggleLoading();
    });
  }

  if (bisButtons) {
    bisButtons.forEach((bisBtn) => {
      bisBtn.addEventListener('click', () => {
        setTimeout(() => {
          if (realBisButton) {
            realBisButton.click();
          }
        }, 500);
      });
    });
  }
};

execOnLoad(window.dAgency.initProductPage, '.product-page__section');
